// extracted by mini-css-extract-plugin
export default {"latest-posts":"LatestPosts_latest-posts__xBVwj"};